import { fork } from 'redux-saga/effects'
import gestionOperativa from '../features/gestion-operativa/redux/sagas'
import stock from '../features/stock/redux/sagas'
import presupuestador from '../features/presupuestador/redux/saga'
import compraUsados from '../features/compra-usados/redux/sagas'
import commissions from '../features/commissions/redux/sagas'
import pricePolicies from '../features/price-policies/redux/sagas'
import leads from '../features/leads/redux/sagas'

export default function* rootSaga() {
  yield fork(gestionOperativa)
  yield fork(stock)
  yield fork(presupuestador)
  yield fork(compraUsados)
  yield fork(commissions)
  yield fork(pricePolicies)
  yield fork(leads)
}
